import React, { useEffect } from 'react';
import Header from "../components/developer_header.jsx";
import Footer from "../components/developer_footer.jsx";

const SkillsDevelopmentLayout = () => {
  const [isMobile, setIsMobile] = React.useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleButtonHover = (e, isHover) => {
    if (isHover) {
      e.target.classList.add('bg-blue-800', 'text-white', 'shadow-lg');
      e.target.classList.remove('bg-blue-600', 'bg-white', 'text-blue-600');
      e.target.style.transform = 'translateY(-2px)';
    } else {
      e.target.classList.remove('bg-blue-800', 'text-white', 'shadow-lg');
      if (e.target.classList.contains('route-button')) {
        e.target.classList.add('bg-blue-600', 'text-white');
      } else {
        e.target.classList.add('bg-white', 'text-gray-800');
      }
      e.target.style.transform = 'translateY(0)';
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col font-sans text-gray-800">
      <Header />
      
      <main className="flex-grow">
        {/* Hero Section - Further reduced bottom padding */}
        <section className="text-center pt-20 pb-2 text-gray-800">
          <div className="container mx-auto px-4 sm:px-6">
            <h1 className={`font-extrabold mb-5 text-gray-700 ${
              isMobile ? 'text-3xl' : 'text-5xl'
            }`}>
              Skills Development
            </h1>
            <p className="text-xl mb-10 text-gray-600 max-w-2xl mx-auto leading-relaxed">
              Welcome! Choose your learning journey and develop <br /> Financial Technology (FinTech) skills through PolyFinTech100 API Hackathon.
            </p>
          </div>
        </section>

        {/* Routes Section - Further reduced top padding */}
        <section className="pt-4 pb-16">
          <div className="container mx-auto px-4 sm:px-6">
            {/* Routes Intro */}
            <div className="text-center mb-16 text-gray-800">
              <h2 className={`font-extrabold mb-5 text-gray-700 ${
                isMobile ? 'text-3xl' : 'text-5xl'
              }`}>
                Environments
              </h2>
              <p className="text-gray-600 text-lg leading-relaxed mb-8 flex-grow">
                Get NETS Micro-credential Certifications in the following environments.
              </p>
            </div>

            {/* Routes Grid - Updated for 3 cards */}
            <div className={`mt-10 ${isMobile ? 'grid grid-cols-1 gap-8' : 'grid grid-cols-3 gap-8'}`}>
              
              {/* Sandbox Environment Card */}
              <div className="route-card bg-white bg-opacity-95 rounded-3xl p-10 shadow-xl transition-all duration-300 relative overflow-hidden flex flex-col h-full border-2 border-gray-100 hover:shadow-2xl hover:-translate-y-3 hover:border-gray-200">
                {/* Top Border */}
                <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-gray-800 to-gray-600 rounded-t-3xl"></div>
                
                {/* Header */}
                <div className="flex items-center justify-center mb-8">
                  <div className="w-15 h-15 rounded-2xl bg-gradient-to-br from-gray-800 to-gray-600 flex items-center justify-center mr-5 text-2xl font-bold text-white">
                    🧪
                  </div>
                  <div className="text-3xl font-bold text-gray-800">Sandbox</div>
                </div>
                
                {/* Description */}
                <p className="text-gray-600 text-lg leading-relaxed mb-8 flex-grow">
                  <b>Suitability: Non-Tech / Tech Participants </b><br />
                  <b>Course Duration: 4 Hours</b> <br />
                  Sandbox Environment for familiarizing NETS payment gateways.
                </p>
                
                {/* Button */}
                <a 
                  href="/certification-journey/sandbox" 
                  className="route-button bg-blue-600 text-white py-4 px-8 rounded-xl text-lg font-semibold cursor-pointer transition-all duration-300 w-full text-center inline-block no-underline hover:bg-blue-700"
                  onMouseEnter={(e) => handleButtonHover(e, true)}
                  onMouseLeave={(e) => handleButtonHover(e, false)}
                >
                  Certify Now
                </a>
              </div>

              {/* UAT Environment Card - Fixed icon gradient */}
              <div className="route-card bg-white bg-opacity-95 rounded-3xl p-10 shadow-xl transition-all duration-300 relative overflow-hidden flex flex-col h-full border-2 border-gray-100 hover:shadow-2xl hover:-translate-y-3 hover:border-gray-200">
                {/* Top Border */}
                <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-gray-600 to-gray-500 rounded-t-3xl"></div>
                
                {/* Header */}
                <div className="flex items-center justify-center mb-8">
                  <div className="w-15 h-15 rounded-2xl bg-gradient-to-br from-gray-600 to-gray-500 flex items-center justify-center mr-5 text-2xl font-bold text-white">
                    🎯
                  </div>
                  <div className="text-3xl font-bold text-gray-800">UAT</div>
                </div>
                
                {/* Description */}
                <p className="text-gray-600 text-lg leading-relaxed mb-8 flex-grow">
                  <b>Suitability: Tech Participants </b><br />
                  <b>Course Duration: 8 Hours</b> <br />
                  Staging environment for validating your FinTech solutions before production.
                </p>
                
                {/* Button */}
                <a 
                  href="/certification-journey/staging/coursework" 
                  className="route-button bg-blue-600 text-white py-4 px-8 rounded-xl text-lg font-semibold cursor-pointer transition-all duration-300 w-full text-center inline-block no-underline hover:bg-blue-700"
                  onMouseEnter={(e) => handleButtonHover(e, true)}
                  onMouseLeave={(e) => handleButtonHover(e, false)}
                >
                  Certify Now
                </a>
              </div>

              {/* Production Environment Card - Disabled Button */}
              <div className="route-card bg-white bg-opacity-95 rounded-3xl p-10 shadow-xl transition-all duration-300 relative overflow-hidden flex flex-col h-full border-2 border-gray-100 hover:shadow-2xl hover:-translate-y-3 hover:border-gray-200">
                {/* Top Border */}
                <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-gray-700 to-gray-600 rounded-t-3xl"></div>
                
                {/* Header */}
                <div className="flex items-center justify-center mb-8">
                  <div className="w-15 h-15 rounded-2xl bg-gradient-to-br from-gray-700 to-gray-600 flex items-center justify-center mr-5 text-2xl font-bold text-white">
                    🚀
                  </div>
                  <div className="text-3xl font-bold text-gray-800">Go Live</div>
                </div>
                
                {/* Description */}
                <p className="text-gray-600 text-lg leading-relaxed mb-8 flex-grow">
                  <b>Suitability: Tech Participants </b><br />
                  <b>Course Duration: 4 Hours</b><br />
                  Production environment where you deploy your FinTech solutions to Bukit Canberra Hawker Centre and Taman Jurong Market & Food Centre (Tentative).
                </p>
                

                <a 
                  href="https://docs.google.com/forms/d/e/1FAIpQLSe2LyW45OXhFpjGCA__1mnT5ps13emqQw2pUAbFtpMi-Edvkw/viewform?usp=dialog"
                  className="route-button bg-blue-600 text-white py-4 px-8 rounded-xl text-lg font-semibold cursor-pointer transition-all duration-300 w-full text-center inline-block no-underline hover:bg-blue-700"
                  onMouseEnter={(e) => handleButtonHover(e, true)}
                  onMouseLeave={(e) => handleButtonHover(e, false)}
                  target="_blank"
                >
                  Challenge Now
                </a>
              </div>

            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default SkillsDevelopmentLayout;